import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import Container from './styled-components/Container';
import Wrapper from './styled-components/Wrapper';
import facebook from '../assets/img/facebook.svg';
import twitter from '../assets/img/twitter.svg';
import instagram from '../assets/img/instagram.svg';
import logo from '../assets/img/logo.svg';
import Image from './styled-components/Image';
import { screen } from '../variables';

export default function Footer() {
  const legal = [
    {
      title: 'Impressum',
      href: '/impressum',
    },
    {
      title: 'AGB',
      href: '/agb',
    },
    {
      title: 'Datenschutz',
      href: '/datenschutz',
    },
  ];

  const socialMedia = [
    { title: 'Facebook', icon: facebook, href: 'https://facebook.com' },
    { title: 'Twitter', icon: twitter, href: 'https://twitter.com' },
    { title: 'Instagram', icon: instagram, href: 'https://instagram.com' },
  ];

  return (
    <StyledFooter>
      <Container backgroundColor="#464949">
        <Wrapper flex footer>
          <FooterNav>
            <span>Rechtliches</span>
            <ul>
              {legal.map((link) => (
                <li key={link.href}>
                  <NavLink to={link.href}>{link.title}</NavLink>
                </li>
              ))}
            </ul>
          </FooterNav>
          <FooterNav flex>
            <span>Social Media</span>
            <ul>
              {socialMedia.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>
                    <img src={link.icon} alt={link.title} />
                  </a>
                </li>
              ))}
            </ul>
          </FooterNav>
          <Logo>
            <div>
              <Image src={logo} alt="Logo" />
              <br />
              <span>© 2020-2021 Choosy GmbH</span>
            </div>
          </Logo>
        </Wrapper>
      </Container>
    </StyledFooter>
  );
}

const StyledFooter = styled.footer`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
`;

const FooterNav = styled.nav`
  color: #fff;
  padding: 48px 0 63px 0;
  flex: 0 0 25%;

  @media (max-width: ${screen.tablet}px) {
    flex: 0 0 50%;

    &:first-child {
      flex: 0 0 50%;
    }
  }

  @media (max-width: 510px) {
    flex: 0 0 auto;
    justify-content: space-between;
  }

  @media (max-width: 340px) {
    padding: 15px 0 63px 0;

    &:first-child {
      padding: 48px 0 63px 0;
    }
  }

  span {
    font-weight: 700;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      border-bottom: 2px solid #74ccc0;
    }
  }

  ul {
    padding: 0;
    margin: 16px 0 0 0;
    list-style-type: none;

    ${(props) =>
      props.flex &&
      `display: flex;
       flex-flow: row wrap;
      `};

    li {
      margin-right: ${(props) => (props.flex ? '24px' : '0')};

      @media (max-width: 510px) {
        margin-right: ${(props) => (props.flex ? '12px' : '0')};
      }

      &:last-child {
        margin-right: 0;
      }

      a {
        color: #fff;
        font-size: 18px;
        text-decoration: none;
      }

      img {
        width: 57px;
        height: 57px;

        @media (max-width: 510px) {
          width: 50px;
          height: 50px;
        }

        @media (max-width: 400px) {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
`;

const Logo = styled.div`
  margin: 84px 0 63px 0;
  flex: 0 0 50%;
  display: flex;
  justify-content: flex-end;

  @media (max-width: ${screen.tablet}px) {
    margin: 0 0 48px 0;
    flex: 0 0 100%;
    justify-content: flex-start;
  }

  div {
    span {
      color: #fff;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;

      @media (max-width: 510px) {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
`;
